import { Inject, Injectable } from '@angular/core';
import { TEMPLATES_REPOSITORY, TemplatesRepository } from '@core/repositories/templates.repository';
import { Template } from '@shared/interfaces/template';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  constructor(
    @Inject(TEMPLATES_REPOSITORY) protected repository: TemplatesRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(template: Template): Observable<any> {
    return this.repository.add(template);
  }

  edit(template: Template): Observable<any> {
    return this.repository.edit(template);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
